import {
    ClientSearchActionTypes,
    ClientSearchEnum,
    ClientSearchType,
    ClientType
} from '../storeTypes'
import { fuzzyMatchCode, fuzzyMatchPhone } from '../helpers/fuzzyMatch'
import { isDefaultClientForPhone } from '../helpers/selectClientFromPhoneMatches'

import { omitBy } from 'lodash'

type SearchObject = {
    client_code: string
    phone: string
}

const searchClient = (
    clients: ClientType[] | [],
    searchParams: Partial<SearchObject>
) => {
    const searchTerms = Object.entries(searchParams)
    const searchResult = clients.filter((client) =>
        searchTerms.find(([key, value]) => {
            if (key === 'phone') {
                return fuzzyMatchPhone(client.phone, value)
            }

            if (key === 'client_code') {
                return fuzzyMatchCode(client.client_code, value)
            }

            return null
        })
    )
    return searchResult
}

const searchClientByPhone = (clients: ClientType[], phone: string) => {
    if (!phone) return []
    return clients.filter((client) => isDefaultClientForPhone(client, phone))
}

const isBlank = (value: string | undefined) => value == null || value === ''

const clientSearchHandler = (
    clientList: ClientType[],
    searchParams: ClientSearchType
): ClientType[] => {
    const { clientId, primaryPhone } = searchParams

    const searchObject: Partial<SearchObject> = {
        client_code: clientId,
        phone: primaryPhone
    }

    return searchClient(clientList, omitBy(searchObject, isBlank))
}

export const clientSearchReducer = (
    state: { searchResult: ClientType[]; searchQuery: ClientSearchType } = {
        searchResult: [],
        searchQuery: {}
    },
    action: ClientSearchActionTypes
): { searchResult: ClientType[]; searchQuery: ClientSearchType } => {
    switch (action.type) {
        case ClientSearchEnum.FETCH_CLIENT_SEARCH: {
            let searchResult = clientSearchHandler(
                action.payload.allClientList,
                action.payload.searchParams
            )
            searchResult = searchResult.filter((result) => !result._is_deleted)
            return {
                ...state,
                searchResult,
                searchQuery: action.payload.searchParams
            }
        }
        case ClientSearchEnum.SEARCH_CLIENT_BY_PHONE: {
            const searchResult = searchClientByPhone(
                action.payload.allClientList,
                action.payload.searchParams.primaryPhone
            ).filter((result) => !result._is_deleted)
            return {
                ...state,
                searchResult,
                searchQuery: action.payload.searchParams
            }
        }
        case ClientSearchEnum.CLEAR_CLIENT_SEARCH:
            return {
                ...state,
                searchResult: [],
                searchQuery: {}
            }
        default:
            return state
    }
}
